import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { SharedModule } from '../../shared/shared.module';
import { RetailerRoutingModule } from './retailer-routing.module';
import { ListPageComponent } from './list-page/list-page.component';
import { FormComponent } from './form/form.component';

@NgModule({
  declarations: [ListPageComponent, FormComponent],
  imports: [
    CommonModule,
    SharedModule,
    RetailerRoutingModule,
  ]
})
export class RetailerModule { }
